import axios from "axios";

export function useCustomerOrderActions(){
  function createVendorCancellation(customerOrder, quantity = null) {
    if(customerOrder.maybeInboundShipmentDate && customerOrder.orderState === 0) {
      return Promise.resolve({
        skipped: true,
        reason: 'Bestellung im Zulauf / im Orderstatus NEU',
      });
    }

    const payload = {
      quantity: quantity ? quantity : customerOrder.customerorderitems[0].quantity,
      customerOrderId: customerOrder.id,
      stockId: customerOrder.customerorderitems[0].stock.id
    };
    return axios.post('/customerorder/action/vendorcancellation', payload)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });


  }

  return {createVendorCancellation}
}